"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
// Copyright 2018 Twitter, Inc.
// Licensed under the Apache License, Version 2.0
// http://www.apache.org/licenses/LICENSE-2.0

var invalidUrlWithoutProtocolPrecedingChars = /[-_.\/]$/;
exports.default = invalidUrlWithoutProtocolPrecedingChars;
module.exports = exports["default"];